import React from "react";
import Swal from "sweetalert2";

export default function useTransaksiErrorToast() {
    const [isError, setIsError] = React.useState(false);

    const notifyError = React.useCallback(() => {
        setIsError(true);
    }, []);

    React.useEffect(() => {
        if (!isError) {
            return;
        }

        void Swal.fire({
            title: "Maaf, kami tidak dapat memproses permintaan anda",
            text: "Silahkan coba lagi dengan memuat ulang halaman",
            position: "top-end",
            showConfirmButton: false,
            icon: "error",
            toast: true,
            width: 600,
            timer: 3000,
            timerProgressBar: true,
            customClass: {
                container: "my-swal",
            },
        });

        setIsError(false);
    }, [isError]);

    return notifyError;
}
